<script>
  // This component contains the positional information of where facet
  // types should be placed on the page.
  import FacetDropdown from './facet-dropdown.svelte';
  import FacetTagList from './facet-tag-list.svelte';
  import Facets from './facets.svelte';

  /** @type {{primary?: boolean}} */
  let { primary = false } = $props();
</script>

<Facets facetType="Tag List" component={FacetTagList} {primary} />
<Facets facetType="Dropdown" component={FacetDropdown} {primary} />
